module.exports = __webpack_public_path__ + "static/img/iconfont.f8ea63a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/iconfont/iconfont.svg
// module id = eueh
// module chunks = 67